export default function getEntity(keyEntities, key) {
  return keyEntities[key];
}